import React, { useEffect, useState, useRef } from "react";
import { User } from "../../types/users";
import { Role } from "../../types/userRoles";
import { getUserRolesById, getUserByName, getUserAD } from "../../services/Administracion/usersService";

interface UserModalProps {
    user: User;
    onClose: () => void;
    onSave: (user: User, rolesAsignados: Role[], rolesBorrados: Role[]) => void;
}

const UserModal: React.FC<UserModalProps> = ({ user, onClose, onSave }) => {
    const [userName, setUserName] = useState<string>(''); //user.ad_username';
    const [fullName, setFullName] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(true);
    const [userAllRoles, setUserAllRoles] = useState<Role[]>([]);
    const [rolesAsignados, setRolesAsignados] = useState<Role[]>([]);
    const [rolesDisponibles, setRolesDisponibles] = useState<Role[]>([]);
    const [isFormValid, setIsFormValid] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ userName?: string; fullName?: string }>({});
    const usernameInputRef = useRef<HTMLInputElement>(null);
    const fullnameInputRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (user.user_id) {
            setUserName(user.ad_username);
            setFullName(user.full_name);
            setIsActive(user.is_active);
            setErrors({});
        }
        if(!user.user_id && usernameInputRef.current){
            usernameInputRef.current.focus();
        } else if(user.user_id && fullnameInputRef.current){
            fullnameInputRef.current.focus();
        }
    }, [user]);

    /// Cargar roles del usuario
    useEffect(() => {
        getUserRolesById(user.user_id)
            .then((data) => {
                console.log('Roles del usuario: ', data.roles);
                setUserAllRoles(data.roles);

                const assigned = data.roles.filter(r => r.is_assigned === 1);
                const available = data.roles.filter(r => r.is_assigned === 0);

                setRolesAsignados(assigned);
                setRolesDisponibles(available);

            })
            .catch((error) => {
                console.error("Error trayendo roles del usuario: ", error);
            })
    }, [user.user_id]);

    useEffect(() => {
        console.log('Pase por useEffect del formulario', userName, fullName);
        const validarForm =
            userName.trim() !== "" &&
            fullName.trim() !== "" &&
            (!errors.userName  && !errors.fullName );

        setIsFormValid(validarForm);

        //console.log("Validación del formulario:", validarForm);
        console.log("Errores: ", errors);
    }, [userName, fullName, isActive, errors])


    const validateUser = async (username: string) => {
        console.log('Validando usuario: ', username);
        try {
            const existingUser = await getUserByName(username);
            console.log('Usuario: ', user);
            if(existingUser) {
                return {
                    isValid : false, 
                    errorMessage: `El usuario: ${existingUser.ad_username} - ${existingUser.full_name} YA existe !!` };
            }
        } catch (error: any) {
            if(error.response?.status !== 404){
                console.error('Error en la validación del usuario: ', error);
                return {
                    isValid: false,
                    errorMessage: "Error interno al verificar el usuario en la BD"
                }
            }
            
        }  
        
        try {
            console.log('Validando usuario en AD: ', username);
            const userAD = await getUserAD(username);
            console.log('Usuario en AD: ', userAD );
            if(!userAD || Object.keys(userAD).length === 0){
                console.log('Usuario no existe en AD');
                return {
                    isValid : false, 
                    errorMessage: `El usuario: ${username} NO existe en el Active Directory !!`
                };
            } else {
                setFullName(userAD.user.name || 'Nombre no disponible');
                return {
                    isValid: true,
                     errorMessage: ''
                };
            }
        } catch (error) {
            console.error('Error en la validación del usuario en AD: ', error);
            return {
                isValid: false,
                errorMessage: "Error interno al verificar el usuario en AD"
            }
        }
    };

    const validateField = async (field: string, value: string) => {
        console.log(`entre a validateField con el field: ${field} valor: ${value}`);
        let errorMessage = '';

        if (value.trim() === "") {
            errorMessage = "Este campo es obligatorio";
        }

        setErrors((prevErrors) => ({ ...prevErrors, [field]: errorMessage }));

        if (field === 'userName' && value.trim() !== "" && !user.user_id) {
            const validation = await validateUser(value);
            console.log('Resultado de la validación: ', validation);
            if(!validation.isValid){
                setErrors((prevErrors) => ({ ...prevErrors, userName: validation.errorMessage }));
                //setIsFormValid(false);
                setFullName('');
            } else {
                //setIsFormValid(true);
                setErrors((prevErrors) => ({ ...prevErrors, userName: '' }));
            }
        }
    }

    const handleAssignRole = (role: Role) => {
        setRolesAsignados([...rolesAsignados, role]);
        setRolesDisponibles(rolesDisponibles.filter(r => r.role_id !== role.role_id));
    };

    const handleRemoveRole = (role: Role) => {
        setRolesDisponibles([...rolesDisponibles, role]);
        setRolesAsignados(rolesAsignados.filter(r => r.role_id !== role.role_id));
    };

    const handleSave = () => {
        const initialAssigned = userAllRoles.filter(r => r.is_assigned);
        const assignedRoles = rolesAsignados.filter(r => !initialAssigned.some(ir => ir.role_id === r.role_id));
        const removedRoles = initialAssigned.filter(r => !rolesAsignados.some(ir => ir.role_id === r.role_id));
        // console.log('Roles definidos iniciales: ', initialAssigned);
        // console.log('Asignados: ', assignedRoles);
        // console.log('Borrar: ', removedRoles);
        onSave({ ...user, ad_username: userName, full_name: fullName, is_active: isActive }, assignedRoles, removedRoles);
    };


    return (
        <div className="modal show d-block" tabIndex={-1} role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content shadow-lg bg-light">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {user.user_id ? 'Editar Usuario' : 'Crear nuevo'}  <span>{user.user_id ? `(${user.user_id})` : ''}</span>
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">Usuario</label>
                            <input
                                type="text"
                                className={`form-control ${errors.userName ? 'is-invalid' : ''}`}
                                //{user.user_id ? true : false}
                                disabled={!!user.user_id}
                                value={userName}
                                onChange={e => setUserName(e.target.value)}
                                onBlur={e => validateField("userName", e.target.value)}
                                required
                                ref={usernameInputRef}
                            />
                            {errors.userName && <div className="invalid-feedback">{errors.userName}</div>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Nombre completo</label>
                            <textarea
                                className={`form-control ${errors.fullName ? 'is-invalid' : ''}`}
                                rows={3}
                                value={fullName}
                                onBlur={e => validateField("fullName", e.target.value)}
                                onChange={e => setFullName(e.target.value)}
                                ref={fullnameInputRef}
                            ></textarea>
                            {errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
                        </div>
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={isActive}
                                onChange={e => setIsActive(e.target.checked)}
                            />
                            <label className="form-check-label">Activo</label>
                        </div>
                        {/*Contenedor de Roles*/}
                        <div className="mb-3">
                            <label className="form-label">Roles</label>
                            {/* Loader mientras los roles se cargan */}
                            {userAllRoles.length === 0 ? (
                                <div className="d-flex flex-column align-items-center p-3 border rounded bg-light">
                                    <div className="spinner-border text-primary mb-2" role="status">
                                        <span className="visually-hidden">Cargando...</span>
                                    </div>
                                    <p className="text-muted">Cargando roles...</p>
                                </div>
                            ) : (
                                <div className="d-flex">
                                    {/* Lista de roles Asignados */}
                                    <div className="w-50 pe-2">
                                        <h6>Asignados</h6>
                                        <div className="border p-2 overflow-auto" style={{ maxHeight: '200px' }}>
                                            {rolesAsignados.length > 0 ? (
                                                rolesAsignados.map((role) => (
                                                    <div key={role.role_id} className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`assigned-${role.role_id}`}
                                                            checked
                                                            onChange={() => handleRemoveRole(role)}
                                                        />
                                                        <label htmlFor={`assigned-${role.role_id}`} className="form-check-label">
                                                            {role.role_name}
                                                        </label>
                                                    </div>
                                                ))
                                            ) : (
                                                <p className="text-muted">No hay roles Asignados</p>
                                            )}
                                        </div>
                                    </div>
                                    {/*Lista de Roles Disponibles */}
                                    <div className="w-50 ps-3 border-start">
                                        <h6>Disponibles</h6>
                                        <div className="border p-2 overflow-auto" style={{ maxHeight: '200px' }}>
                                            {rolesDisponibles.length > 0 ? (
                                                rolesDisponibles.map((role) => (
                                                    <div key={role.role_id} className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`available-${role.role_id}`}
                                                            onChange={() => handleAssignRole(role)}
                                                        />
                                                        <label htmlFor={`available-${role.role_id}`} className="form-check-label">
                                                            {role.role_name}
                                                        </label>
                                                    </div>
                                                ))
                                            ) : (
                                                <p className="text-muted">No hay roles disponibles</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                        <button type="button"
                            disabled={!isFormValid}
                            className="btn btn-primary"
                            onClick={handleSave}
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default UserModal;